module.exports = __webpack_public_path__ + "static/media/gulp-logo.b32b27ea.png";